export default __webpack_public_path__ + "dc083f46ffed571c6c5b0e018a6fca8c.glb";